// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function fromUrl(param) {
  return "Particle";
}

var home = "/";

exports.fromUrl = fromUrl;
exports.home = home;
/* No side effect */
